"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActiveLinkMenuItems;
var _react = require("react");
const findActiveLinkItem = menuItems => {
  const currList = [...menuItems];
  const isActiveEntrySet = currList.find(entry => entry?.active);
  if (global?.location && !isActiveEntrySet) {
    const decodedPagePathSubStr = decodeURIComponent(global.location.pathname).replace(/\/$/, '');
    const currentItemIndex = currList.findIndex(entry => entry?.href?.includes(decodedPagePathSubStr));
    return currentItemIndex >= 0 ? currentItemIndex : null;
  }
  return null;
};
function useActiveLinkMenuItems(menuItems) {
  const [currentMenuItems, setCurrentMenuItems] = (0, _react.useState)(menuItems || []);
  (0, _react.useEffect)(() => {
    const activeItemIndex = findActiveLinkItem(currentMenuItems);
    const currList = [...currentMenuItems];
    if (activeItemIndex !== null && activeItemIndex >= 0) {
      currList[activeItemIndex].active = true;
    }
    setCurrentMenuItems(currList);
  }, [global?.location?.pathname]);
  return currentMenuItems;
}